"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function DarkModeIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("polygon", { points: "5.881 3.071 7.046 5.431 9.651 5.81 7.766 7.647 8.211 10.242 5.881 9.017 3.551 10.242 3.996 7.647 2.111 5.81 4.716 5.431 5.881 3.071" }),
        react_1.default.createElement("path", { d: "M11.2,22.133a10.775,10.775,0,0,1-4.53-1,.85.85,0,0,1,.022-1.553A14.362,14.362,0,0,0,15.423,6.355a14.471,14.471,0,0,0-.43-3.435.85.85,0,0,1,1.227-.952A10.719,10.719,0,0,1,11.2,22.133ZM9.207,20.207A9.014,9.014,0,0,0,17.015,4.553a15.305,15.305,0,0,1,.108,1.8A16.058,16.058,0,0,1,9.207,20.207Z" }),
        react_1.default.createElement("rect", { fill: "none", width: "24", height: "24" })));
}
exports.default = DarkModeIcon;
